export default __webpack_public_path__ + "static/media/iso1pk.e6e2e064.svg";